import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { TipoPromocaoCampanhaSelectComponent } from './select';
import { TipoPromocaoCampanhaMultiselectComponent } from './multiselect';
import { TipoPromocaoCampanhaPipe, TipoPromocaoCampanhaApresentacaoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TipoPromocaoCampanhaSelectComponent,
        TipoPromocaoCampanhaMultiselectComponent,

        // Pipes
        TipoPromocaoCampanhaPipe,
        TipoPromocaoCampanhaApresentacaoPipe
    ],
    exports: [
        TipoPromocaoCampanhaSelectComponent,
        TipoPromocaoCampanhaMultiselectComponent,

        // Pipes
        TipoPromocaoCampanhaPipe,
        TipoPromocaoCampanhaApresentacaoPipe
    ],
    providers: [
        // Pipes
        TipoPromocaoCampanhaPipe,
        TipoPromocaoCampanhaApresentacaoPipe
    ]
})
export class TipoPromocaoCampanhaModule { }
